import { MaterialIcon } from "@website/icons/material";

export const times = [
  {
    icon: <MaterialIcon name="nights_stay" variant="outlined" />,
    text: "بامداد",
    timeText: "0:0 - 6",
    value: "00:00-06:00"
  },
  {
    icon: <MaterialIcon name="wb_twilight" variant="outlined" />,
    text: "صبح",
    timeText: "6 - 12",
    value: "06:00-12:00"
  },
  {
    icon: <MaterialIcon name="wb_sunny" variant="outlined" />,
    text: "ظهر/عصر",
    timeText: "12 - 18",
    value: "12:00-18:00"
  },
  {
    icon: <MaterialIcon name="bedtime" variant="outlined" />,
    text: "شب",
    timeText: "18 - 24",
    value: "18:00-00:00"
  }
] as const;
